import React, { useState } from 'react';
import Button from '../../../components/ui/Button';

const AddUserForm = ({ onAddUser, loading }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password.trim()) {
      setError('Username and password are required');
      return;
    }
    try {
      await onAddUser(username, password, role);
      setUsername('');
      setPassword('');
      setRole('user');
    } catch (err) {
      setError(err.message || 'Failed to add user');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-8 max-w-xl mx-auto bg-card border border-border rounded-lg p-6 flex flex-col gap-4">
      <h3 className="text-lg font-semibold mb-2">Add New User</h3>
      {error && <div className="text-red-500 text-sm mb-2">{error}</div>}
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={e => setUsername(e.target.value)}
        className="border rounded px-3 py-2"
        autoComplete="off"
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        className="border rounded px-3 py-2"
        autoComplete="new-password"
      />
      <select
        value={role}
        onChange={e => setRole(e.target.value)}
        className="border rounded px-3 py-2"
      >
        <option value="user">User</option>
        <option value="admin">Admin</option>
      </select>
      <Button type="submit" variant="success" loading={loading}>
        Add User
      </Button>
    </form>
  );
};

export default AddUserForm;
